import React, { Component } from 'react'
import { WithRouterProps, withRouter } from '../components/shared/WithRouter'
import { CLIENT_SCREEN_TYPES } from '../utils/RoutesUtil';
import QuestionnaireReview from "../components/ClientPortal/Questionarie/QuestionarieComponent";
import ClientQuestionarie from '../components/ClientPortal/Questionarie/ClientQuestionarie';

class ClientPortalQuestionarie extends Component<
WithRouterProps<unknown>,
any
> {
  componentDidMount(): void {
    // console.log(this.props.location.state)
  }
  render() {
    return (
      <>
        {this.props.params.screenType?.toLowerCase()===CLIENT_SCREEN_TYPES.COMPLIANCE_VIEW && <QuestionnaireReview/>}
        {this.props.params.screenType?.toLowerCase()===CLIENT_SCREEN_TYPES.CLIENT_VIEW && <ClientQuestionarie/>}
        </>
    )
  }
}

export default withRouter<WithRouterProps<unknown>>(ClientPortalQuestionarie)
